import { render, staticRenderFns } from "./DisplayJeuModal.vue?vue&type=template&id=adfe8a1c&scoped=true"
import script from "./DisplayJeuModal.vue?vue&type=script&lang=js"
export * from "./DisplayJeuModal.vue?vue&type=script&lang=js"
import style0 from "./DisplayJeuModal.vue?vue&type=style&index=0&id=adfe8a1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adfe8a1c",
  null
  
)

export default component.exports